import React from 'react';
import { NavBannerProps } from '..';
import { LOCAL_COLORS } from 'styles/constants';
import type { IconName } from '@curology/ui-components-web/react/Icon/DynamicIcon';

export const POP_REDESIGN_BANNER_CONTENT: NavBannerProps = {
  backgroundColor: LOCAL_COLORS.surfaceOrange,
  textColor: LOCAL_COLORS.surfaceDarkBold,
  iconName: 'gift',
  text: <React.Fragment>Get 50% off your first box</React.Fragment>,
};

export const getBannerPropsFromLdFlagValue = (
  curologySiteIntroOfferBannerCopy?: string,
) => {
  if (curologySiteIntroOfferBannerCopy) {
    const iconRegex = /\[icon:(.*?)\]/;
    const match = curologySiteIntroOfferBannerCopy.match(iconRegex);
    let iconName;

    if (match && match[1]) {
      // Use the matched icon name directly as a string
      iconName = match[1];
    }

    const text = curologySiteIntroOfferBannerCopy.replace(iconRegex, '');

    return {
      ...POP_REDESIGN_BANNER_CONTENT,
      iconName: iconName as IconName,
      text: <React.Fragment>{text}</React.Fragment>,
    };
  }

  return POP_REDESIGN_BANNER_CONTENT;
};
